export const DEFAULT_PRICE_DECIMALS = 2
export const HANDICAP = 'HANDICAP'
export const DEFAULT = 'DEFAULT'
export const FRACTION_PICKS = 'FRACTION'
export const TOTALS = 'TOTALS'

export const AMERICAN = 'American'
export const DECIMAL = 'Decimal'
export const FRACTION = 'Fraction'
export const HONG_KONG = 'Hong Kong'
export const INDONESIAN = 'Indonesian'
export const MALAYSIAN = 'Malaysian'
export const ITALIAN = 'Italian'
export const PERCENTAGE = 'Percentage'
export const WINNINGS = 'Winnings'

export const TOTAL_PERCENT = 100
export const MALAYSIAN_PRICE_DECIMALS = 2
export const oddTypeSP = { VALUE: -1, LABEL: 'SP' }

export const DRAW_PARTID = 15145
export const OVER_PARTID = 15143
export const UNDER_PARTID = 15144
export const TOTAL_PARTID = 'totals'
export const SECOND = 1
export const FORMATS_WITH_DRAW = ['DEFAULT', 'DRAW']
export const PARTICIPANT_ORDER = {
  AMERICAN: 'AMERICAN',
  WORLD: 'WORLD',
}
export const DRAW = {
  partid: DRAW_PARTID,
  nam: 'Draw',
  ih: false,
  isDrawParticipant: true,
  source: { nam: 'Draw', tmid: 1, imageurl: '' },
}
